import type { ReactElement } from 'react';

import type { DrupalSection } from '@commons/types/drupal';

import BannerSection from './Banner';
import BasicSection from './Basic';
import BlankSection from './Blank';
import ColumnsSection from './Columns';
import GridSection from './Grid';
import PartialFluidSection from './PartialFluid';
import TilesSection from './Tiles';

/**
 * Enum of all available section types.
 *
 * Makes it easier to read and edit the ids.
 */

export enum SECTION_TYPE {
  Grid = 'pure_pagebuilder_grid',
  Basic = 'pure_pagebuilder_basic',
  Blank = 'layout_builder_blank',
  Banner = 'pure_pagebuilder_banner',
  Columns = 'pure_pagebuilder_columns',
  PartialFluid = 'pure_pagebuilder_partial_fluid',
  Tiles = 'pure_pagebuilder_tiles',
}

/**
 * Type definition for a section component.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Section = (props: DrupalSection<any>) => ReactElement;

/**
 * Type definition for a sections factory.
 */

export type SectionsFactory = Record<string, Section>;

/**
 * Factory of all available sections.
 */

export const sections: SectionsFactory = {
  [SECTION_TYPE.Grid]: GridSection,
  [SECTION_TYPE.Basic]: BasicSection,
  [SECTION_TYPE.Blank]: BlankSection,
  [SECTION_TYPE.Banner]: BannerSection,
  [SECTION_TYPE.Columns]: ColumnsSection,
  [SECTION_TYPE.PartialFluid]: PartialFluidSection,
  [SECTION_TYPE.Tiles]: TilesSection,
};
